export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10651.ff68da36.jpg";